import { useNavigate } from "react-router-dom";
import SEO from "../SEO/SEO"

const AboutSection = () => {
  const features = [
    { title: "Quality Assurance", desc: "ISO certified standards" },
    { title: "On-time Delivery", desc: "Timely project completion" },
    { title: "Global Network", desc: "Worldwide partnerships" },
    { title: "Expert Support", desc: "24/7 technical assistance" },
  ];

  const navigate = useNavigate();

  const handleInquiry = () => {
    navigate("/about");
  };
  const handlecontact = () => {
    navigate("/contact");
  };

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6">
      <SEO
        title="About Us | Nexora Machinery"
        description="Learn about Nexora Machinery, a trusted supplier of CNC Turning Centers, VMC Machines, Milling Machines, Tapping Machines and industrial machinery."
        keywords="About Nexora Machinery, Tapping machine, CNC Machine Supplier"
        path="/about"
      />
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image Section */}
          <div className="relative">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="/images/aboutnexora.png"
                alt="Nexora Machinery"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-white rounded-lg shadow-lg p-4">
              <div className="text-xl font-bold text-[#002946]">10+</div>
              <div className="text-xs text-gray-600">Years Experience</div>
            </div>
          </div>

          {/* Content Section */}
          <div className="space-y-6">
            <div>
              <div className="text-[#00d9ff] font-semibold text-sm uppercase tracking-wide mb-2">
                About Us
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#002946] mb-4">
                Leading Industrial Machinery Solutions
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Nexora Machinery delivers innovative industrial machinery
                solutions with reliable, high-performance equipment designed for
                efficiency and durability.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3 p-3 rounded-lg bg-gray-50"
                >
                  <div className="w-6 h-6 bg-[#00d9ff] rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-sm font-bold">✓</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#002946] text-sm">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-xs">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <button
                onClick={handleInquiry}
                className="bg-[#002946] text-white px-6 py-3 rounded-lg font-semibold text-sm transition-colors duration-200 hover:bg-[#004e7c] active:scale-95"
              >
                Learn More
              </button>
              <button
                onClick={handlecontact}
                className="border border-[#002946] text-[#002946] px-6 py-3 rounded-lg font-semibold text-sm transition-colors duration-200 hover:bg-[#002946] hover:text-white active:scale-95"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
